export default __webpack_public_path__ + "media/images/features/saga/plane-3c60551be2544976714a55791e2f1c6e.png";